import api from './api';
import { Message, SendMessageRequest } from '../types/message.types';

interface RawMessage {
  id: string;
  project_id: string;
  role: 'user' | 'assistant';
  content: string;
  created_at: string;
}

function normalize(raw: RawMessage): Message {
  return {
    id: raw.id,
    projectId: raw.project_id,
    role: raw.role,
    content: raw.content,
    createdAt: raw.created_at,
  };
}

export const messageService = {
  async getMessages(projectId: string): Promise<Message[]> {
    const response = await api.get<{ messages: RawMessage[] }>(`/api/projects/${projectId}/messages`);
    return response.data.messages.map(normalize);
  },

  async sendMessage(
    projectId: string,
    data: SendMessageRequest
  ): Promise<{ userMessage: Message; assistantMessage: Message }> {
    const response = await api.post<{ userMessage: RawMessage; assistantMessage: RawMessage }>(
      `/api/projects/${projectId}/messages`,
      data
    );
    return {
      userMessage: normalize(response.data.userMessage),
      assistantMessage: normalize(response.data.assistantMessage),
    };
  },
};
